import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newBritainConfig } from "./data";

export default function NewBritainPage() {
  return <CityPageTemplate config={newBritainConfig} />;
}